import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAttributes, IController, IFormController, IModule} from "angular";
import {l} from "../../../types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {nullSikkerListe} from "felles/stoettefunk/lister";
import {erIkkeNill, erNill} from "felles/stoettefunk/nillsjekk";

const css = require('./medlemSelect.scss');

/**
 * Nedtrekksmeny for valg av gruppmedlemmer
 */
export class MedlemSelect implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wkMedlemSelect', {
                bindings: {
                    valgteMedlemmer: '=',
                    laasteMedlemmer: '=',
                    medlemmer: '<',
                    skjema: '<?',
                    feltnavn: '@?', /*settes til 'medlemSelect' dersom ikke angitt */
                    label: '@',
                    visKunAvatar: '@',
                    visIkon: '@',
                    inputContainerClass: '@',
                    vedAapneMeny: '&',
                    vedLukkMeny: '&'
                },
                controller: MedlemSelect.forInjisering(),
                template: require('./medlemSelect.html'),
                transclude: true
            })
    }

    static forInjisering() {
        return [regNavn.ng.$attrs, MedlemSelect]
    }

    constructor(private $attrs: IAttributes) {
    }

    valgteMedlemmer: l.GruppeMedlemListeModell[] | l.GruppeMedlemListeModell; //settes via bindings
    laasteMedlemmer: l.GruppeMedlemListeModell[]; //settes via bindings
    medlemmer: l.GruppeMedlemListeModell[]; //settes via bindings
    skjema: IFormController; //settes via bindings
    feltnavn: string; //settes via bindings
    label: string; //settes via bindings
    visKunAvatar: 'true' | 'false' = 'false'; //settes via bindings
    visIkon: 'true' | 'false' = 'false'; //settes via bindings
    inputContainerClass: string = ''; //settes via bindings

    multiple: boolean;
    required: boolean;
    tilgjengeligeMedlemmer: l.GruppeMedlemListeModell[];

    erLaast(kandidat:l.GruppeMedlemListeModell): boolean{
        return _(this.laasteMedlemmer).some(obligatorisk => obligatorisk.id === kandidat.id);
    }

    // feltet markeres med feil selvom det ikke har vært redigert i. lagt til når ansvarlig på oppgave kunne være ett tekstfelt etter sp2 migrering.
    erFeltetUGyldig(): boolean {
        if (!this.required || erNill(this.skjema) || erNill(this.skjema.medlemSelect)) return false;
        return this.skjema.medlemSelect.$invalid
    }

    $onInit(): void {
        //kan ikke bruker bindings på disse da deres verdi ikke er tilgjengelig før
        //md-select rendrer - noe som fører til muliple md-select inne i md-input-container
        //hvorpå angular-material skriker
        this.multiple = this.$attrs['multiple'] === 'true';
        this.required = this.$attrs['required'] === 'true';

        if (_.isEmpty(this.feltnavn)) this.feltnavn = 'medlemSelect';
    }

    $onChanges(endringer: angular.IOnChangesObject) {
        dersomChangesInneholder(endringer, 'medlemmer', medlemmer => {
            this.initTilgjengeligeMedlemmer();
            if (this.required && _.isEmpty(this.valgteMedlemmer)) {
                this.leggTilFeil();
            }
        });
        dersomChangesInneholder(endringer, 'valgteMedlemmer', valgteMedlemmer => {
            this.initTilgjengeligeMedlemmer();
            if (!_.isEmpty(valgteMedlemmer)) {
                this.fjernFeil();
            }
        });
    }

    //private hjelpemetoder

    private initTilgjengeligeMedlemmer() {
        this.tilgjengeligeMedlemmer = _.unionBy(nullSikkerListe(this.medlemmer), this.valgteMedlemmerSomListe(), medlem => medlem.id);
    }

    private leggTilFeil() {
        if (erIkkeNill(this.skjema?.medlemSelect))
            this.skjema.medlemSelect.$setValidity("required", false);
    }

    private fjernFeil() {
        if (erIkkeNill(this.skjema?.medlemSelect))
            this.skjema.medlemSelect.$setValidity("required", true);
    }

    private valgteMedlemmerSomListe(): l.GruppeMedlemListeModell[] {
        if (erNill(this.valgteMedlemmer)) return [];
        return <l.GruppeMedlemListeModell[]>(this.multiple ? this.valgteMedlemmer : [this.valgteMedlemmer]);
    }

}
